"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMasterDocument = decodeMasterDocument;
exports.buildInstanceHashMap = buildInstanceHashMap;
exports.buildInstanceHashSet = buildInstanceHashSet;
exports.buildNetHashMap = buildNetHashMap;
exports.buildNetHashSet = buildNetHashSet;
const entity_list_1 = require("./entity-list");
const decode_master_page_ref_1 = require("./decode-master-page-ref");
const decode_master_style_assignments_1 = require("./decode-master-style-assignments");
const STYLE_ASSIGNMENTS_ROOT_INDEX = 0;
const PAGE_REFS_ROOT_INDEX = 6;
const HASH_PATTERN = /^\d{16,22}$/;
function decodeMasterDocument(root, path, warnings) {
    const rootSlots = root.children.map((slot, rootIndex) => decodeRootSlot(slot, rootIndex, `${path}/root[${rootIndex}]`, warnings));
    const pageRefs = (0, decode_master_page_ref_1.decodeMasterPageRefs)(root.children[PAGE_REFS_ROOT_INDEX], `${path}/root[${PAGE_REFS_ROOT_INDEX}]`, warnings);
    const styleAssignments = (0, decode_master_style_assignments_1.decodeMasterStyleAssignments)(root.children[STYLE_ASSIGNMENTS_ROOT_INDEX], `${path}/root[${STYLE_ASSIGNMENTS_ROOT_INDEX}]`, warnings);
    return {
        kind: 'master',
        rootSlots,
        pageRefs,
        styleAssignments,
        raw: root,
    };
}
function decodeRootSlot(slot, rootIndex, path, _warnings) {
    if (slot.type !== 'container' && slot.type !== 'econtainer') {
        return slot;
    }
    const detected = (0, entity_list_1.detectEntityList)(slot.children);
    const declaredTypeCode = detected === null ? null : detected.typeCode;
    const declaredCount = detected === null ? null : detected.declaredCount;
    const itemCount = detected === null ? slot.children.length : (0, entity_list_1.entityListItems)(slot).length;
    const hashes = collectHashes(slot);
    void path;
    return {
        kind: 'master-root-slot',
        rootIndex,
        declaredTypeCode,
        declaredCount,
        itemCount,
        hashes,
        raw: slot,
    };
}
function collectHashes(node) {
    const out = new Set();
    function walk(n) {
        if (n.type === 'atom' || n.type === 'name' || n.type === 'value' || n.type === 'text') {
            for (const piece of n.content.split(/\s+/)) {
                if (HASH_PATTERN.test(piece)) {
                    out.add(piece);
                }
            }
            return;
        }
        if (n.type === 'container' || n.type === 'econtainer') {
            for (const child of n.children) {
                walk(child);
            }
        }
    }
    walk(node);
    return [...out];
}
const MIN_HASH_LEN = 16;
function buildInstanceHashMap(master) {
    return buildKeyedTextRowMap(master, 11);
}
function buildInstanceHashSet(master) {
    return buildHashSet(master, 11);
}
function buildNetHashMap(master) {
    return buildKeyedTextRowMap(master, 12);
}
function buildNetHashSet(master) {
    return buildHashSet(master, 12);
}
function buildKeyedTextRowMap(master, rootIndex) {
    const out = new Map();
    const slot = master.rootSlots[rootIndex];
    if (!slot) {
        return out;
    }
    const raw = 'raw' in slot ? slot.raw : slot;
    if (raw.type !== 'container' && raw.type !== 'econtainer') {
        return out;
    }
    for (const child of raw.children) {
        if (child.type !== 'text') {
            continue;
        }
        const tokens = child.content.trim().split(/\s+/);
        if (tokens.length < 3) {
            continue;
        }
        const [tok0, tok1, tok2, ...rest] = tokens;
        if (isLongHash(tok2)) {
            out.set(`${tok1}:${tok2}`, tok0);
            continue;
        }
        if (isLongHash(tok1)) {
            const value = [tok2, ...rest].join(' ');
            out.set(`${tok0}:${tok1}`, value);
            continue;
        }
    }
    return out;
}
function buildHashSet(master, rootIndex) {
    const out = new Set();
    const slot = master.rootSlots[rootIndex];
    if (!slot) {
        return out;
    }
    const raw = 'raw' in slot ? slot.raw : slot;
    if (raw.type !== 'container' && raw.type !== 'econtainer') {
        return out;
    }
    function walk(node) {
        switch (node.type) {
            case 'atom':
            case 'name':
            case 'value':
            case 'text':
                for (const piece of node.content.split(/\s+/)) {
                    if (isLongHash(piece)) {
                        out.add(piece);
                    }
                }
                return;
            case 'raw-blob':
                return;
            case 'container':
            case 'econtainer':
                for (const child of node.children) {
                    walk(child);
                }
                return;
        }
    }
    walk(raw);
    return out;
}
function isLongHash(s) {
    return s.length >= MIN_HASH_LEN && /^\d+$/.test(s);
}
//# sourceMappingURL=decode-master-document.js.map